import React from "react";
import OrderCard from "./OrderCard";
import { compareDay, orderViewParameters, shortenLanguage } from "../functions";
import { isSameDay } from "../main/WorkTime";
import PAPOrderDer from "./PAPOrderDer";
import papIcon from "../../images/clients/pap-60x35.png";
import prettyNumber from "../tables/functions/prettyNumber";

function ordersView(props) {
  const {
    orders,
    date,
    customOrders,
    details,
    setDetails,
    view,
    params,
    heading,
    past,
    style,
  } = props;

  let classNm = "";
  switch (view) {
    case "cards":
      classNm = "orderCollection";
      break;
    case "table":
      classNm = "orderTable";
      break;
  }
  let customOrdersProcessed;
  if (customOrders) {
    customOrdersProcessed = customOrders
      .map((item) => {
        return {
          ...item,
          custom: true,
          orderDateJS: new Date(item.finish_date),
          orderHour: new Date(item.finish_date).toLocaleTimeString("pl-PL", {
            hour: "numeric",
            minute: "numeric",
          }),
          orderNumber: "X" + item.number_order,
          valid_order: "X" + item.number_order,
          language_from_short: shortenLanguage(item.language_from),
          language_to_short: shortenLanguage(item.language_to),
          docPages: 0,
          docPagesNormal: 0,
          docPagesSworn: 0,
          docPagesSwornRounded: 0,
          remarks_translators: item.comments,
        };
      })
      .filter((item) => isSameDay(item.orderDateJS, date));
  }

  const ordersCombined =
    customOrdersProcessed && orders
      ? [...orders, ...customOrdersProcessed].sort((a, b) =>
          a.orderHour.localeCompare(b.orderHour)
        )
      : orders;

  const noPAP = ordersCombined?.filter((item) => {
    if (
      item?.customers_name?.match("Polska Agencja Prasowa S.A.") &&
      item?.documents?.length === 1
    ) {
      return false;
    } else return true;
  });

  const PAP = ordersCombined?.filter((item) => {
    if (
      item?.customers_name?.match("Polska Agencja Prasowa S.A.") &&
      item?.documents?.length === 1
    ) {
      return true;
    } else return false;
  });
  PAP?.sort((a,b) => new Date(a?.reception_date)?.getTime() - new Date(b?.reception_date)?.getTime());

  console.log("combined", ordersCombined, noPAP);
  return (
    <div className="order-columns">
      <div className={classNm + (past ? " _past" : "")} style={style}>
        {noPAP &&
          noPAP.map((item) => (
            <OrderCard
              key={item.id}
              item={item}
              params={params}
              details={details}
              setDetails={setDetails}
              view={props.view}
              dayInfo={heading ? true : false}
              past={past}
            />
          ))}
      </div>
      {PAP && PAP?.length ? (
        <>
          <div className="pap-head-wrap">
            <div>
              <img src={papIcon} />{" "}
              <h1 className="pap-head">INFORMACJE DO TŁUMACZENIA</h1>
            </div>
            <div className="orderStatistics" style={{ padding: "2px 10px" }}>
              {PAP?.length} inf. <span>|</span>
              <span>
                {prettyNumber(
                  PAP?.map((p) => {
                    const d = p?.documents?.at(0);
                    const pages = parseFloat(d?.pages_count_translator);
                    return (
                      Math.round((Math.round(pages * 100) / 100) * 1600) / 1000
                    );
                  })?.reduce((a, b) => a + b, 0),
                  { round: 2, postfix:"tys. zn." }
                )}
                
              </span>
            </div>
          </div>
          <div
            className={"pap-wrap " + classNm + (past ? " _past" : "")}
            // style={style}
          >
            {PAP &&
              PAP?.map((item) => (
                <PAPOrderDer
                  key={item.id}
                  data={item}
                  view={item && orderViewParameters(item)}
                  details={details}
                  params={params}
                  setDetails={setDetails}
                  dayInfo={heading ? true : false}
                  past={past}
                />
              ))}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}

export default ordersView;
